/**
 * beneficiosService.js — cliente del módulo "Beneficios Cantabria".
 *
 * Pega contra /api/beneficios/* del backend, que a su vez habla con la API de
 * BI del portal de promociones (cantabri_api_bi). El token Bearer del portal
 * vive en el backend (BENEFICIOS_API_TOKEN): aquí no se maneja nunca.
 */

const API = process.env.REACT_APP_STRANDS_API_URL || 'http://localhost:5001';

async function jsonFetch(url) {
  const res = await fetch(url, { cache: 'no-store' });
  let data = {};
  try { data = await res.json(); } catch (_) { /* sin cuerpo */ }
  if (!res.ok) {
    const err = new Error(data.error || `HTTP ${res.status}`);
    err.status = res.status;
    err.code = data.code;
    throw err;
  }
  if (data && data.success === false) {
    const err = new Error(data.error || 'Error desconocido');
    err.code = data.code;
    throw err;
  }
  return data;
}

export const beneficiosApi = {
  /** ¿Hay token configurado y qué tenants se permiten? */
  status: () => jsonFetch(`${API}/api/beneficios/status`),

  /** Payload único con todo el tablero para un tenant del portal. */
  overview: (tenant, { refresh = false } = {}) =>
    jsonFetch(`${API}/api/beneficios/overview?tenant=${encodeURIComponent(tenant || '')}${refresh ? '&refresh=1' : ''}`),
};

export default beneficiosApi;
